import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/Layout';
import SEO from 'components/SEO';
import Hero from 'components/Hero';
import ContentList from 'components/ContentList.jsx';
import GridPeople from 'components/_page/about/GridPeople.jsx';
import OurTeam from 'components/_page/about/OurTeam.jsx';
import Trapdoor from 'components/Trapdoor.jsx';

export default ({ data }) => {
  const about = data.prismic.allAbout_uss.edges[0].node;

  return (
    <Layout>
      <SEO
        title={about.social_title || 'About Us'}
        description={about.social_description ? about.social_description : null}
        image={about.social_image ? about.social_image.url : null}
      />

      <Hero
        heading={about.hero_heading}
        content={about.hero_content}
        image={about.hero_image}
        illustration={about.hero_illustration}
        imagePosition='right'
        variant='colored'
        size='large'
      />

      <ContentList
        intro={about.content_list_intro}
        heading={about.content_list_heading[0].text}
        content={about.content_list_content}
        items={about.content_list}
        variant='about'
      />

      <OurTeam
        heading={about.our_team_heading}
        image={about.our_team_image}
        content={about.our_team_content}
        secondaryHeading={about.our_team_secondary_heading}
      />

      {about.management_members.length > 0 && (
        <GridPeople
          heading={about.management_heading}
          people={about.management_members}
          anchor='management'
        />
      )}

      {about.board_members.length > 0 && (
        <GridPeople
          heading={about.board_heading}
          people={about.board_members}
          anchor='board'
        />
      )}

      <Trapdoor
        intro={about.join_us_intro}
        heading={about.join_us_heading}
        buttonText={about.join_us_button_text}
        destination={about.join_us_destination}
      />
    </Layout>
  );
};

export const query = graphql`
  {
    prismic {
      allAbout_uss {
        edges {
          node {
            hero_content
            hero_heading
            hero_image
            hero_illustration {
              ... on PRISMIC__FileLink {
                _linkType
                name
                size
                url
              }
            }
            content_list {
              content
              heading
              image
              illustration {
                ... on PRISMIC__FileLink {
                  _linkType
                  name
                  size
                  url
                }
              }
            }
            content_list_content
            content_list_heading
            content_list_intro
            our_team_content
            our_team_heading
            our_team_image
            our_team_secondary_heading
            management_heading
            board_heading
            management_members {
              member {
                ... on PRISMIC_Person {
                  _meta {
                    uid
                  }
                  name
                  title
                  image
                }
              }
            }
            board_members {
              member {
                ... on PRISMIC_Person {
                  _meta {
                    uid
                  }
                  name
                  title
                  image
                }
              }
            }
            join_us_intro
            join_us_heading
            join_us_button_text
            join_us_destination
          }
        }
      }
    }
  }
`;
